export default "__VITE_ASSET__DXzEdA7N__"